export function isUrl(value: string): boolean {
	return /^(?:https?:\/\/|\/|data:)/.test(value);
}
